import { useEffect, useState } from 'react';

const matches = (query) =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches;

// True while the media query matches; false where matchMedia is missing (jsdom, old browsers).
export const useMediaQuery = (query) => {
  const [hit, setHit] = useState(() => matches(query));
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const on_change = () => setHit(mql.matches);
    on_change();
    if (mql.addEventListener) mql.addEventListener('change', on_change);
    else mql.addListener(on_change);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', on_change);
      else mql.removeListener(on_change);
    };
  }, [query]);
  return hit;
};
